import styled from "styled-components";
import colors from "theme/colors.module.scss";
import shadows from "theme/shadows.module.scss";
import spacing from "theme/spacing.module.scss";
import borders from "theme/borders.module.scss";
import { Button } from "antd";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;

  .main-logo {
    margin-bottom: ${spacing.spacing};
    width: 120px;
    height: 120px;
    z-index: 1;
  }

  svg {
    color: ${colors.primaryPurple500};
  }

  .ant-btn-loading-icon {
    svg {
      color: ${colors.primaryBackground};
    }
  }

  a {
    color: ${colors.primaryPurple500};
    font-weight: 400;
    text-decoration: underline;
    width: fit-content;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: ${borders.borderRadiusSM};
  flex: 1;
  border: none;
  margin-top: ${spacing.spacingXL};
`;

export const Form = styled.form`
  padding: ${spacing.spacingLG} ${spacing.spacing} ${spacing.spacingXL};
  border-top-left-radius: ${borders.borderRadiusXXL};
  border-top-right-radius: ${borders.borderRadiusXXL};
  position: absolute;
  bottom: 0;
  background-color: ${colors.primaryBackground};
  width: 100%;
  box-shadow: ${shadows.secondaryShadow};
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 25%;
  justify-content: center;
  align-items: center;
`;

export const CircleImage = styled.div`
  position: absolute;
  width: 100%;
  height: 380px;
  top: calc(25% - 380px / 2);

  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(214, 185, 251, 0.6) 0%,
    rgba(214, 185, 251, 0.4) 100%
  );
  filter: blur(38px);
`;
